import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useRef } from 'react';
import WrapperButton from '../../../../components/buttons/WrapperButton';
import { useQuery } from '@tanstack/react-query';
import { ApiError } from '../../../../Interfaces/system/Generic.interfaces';
import ErrorToast, {
  showToast,
} from '../../../../components/messages/ErrorAlert';
import { Toast } from 'primereact/toast';
import { downloadFile } from '@/src/utils/fileUtil';
import { fetchClaimLogAttachment } from '@/src/app/services/Insurance/Claim';

type ClaimLogAttachmentProps = {
  claimID: string;
  attachmentName?: string;
  logID: string;
};

const ClaimLogAttachment = ({
  claimID,
  attachmentName,
  logID,
}: ClaimLogAttachmentProps) => {
  const toast = useRef<Toast>(null);

  const { isFetching, refetch } = useQuery({
    queryKey: ['getClaimLogAttachments', claimID, logID],
    queryFn: ({ signal }) => fetchClaimLogAttachment(claimID, logID, signal),
    refetchOnWindowFocus: false,
    enabled: false,
    onSuccess: (data) => {
      downloadFile(data, attachmentName);
    },
    onError: (error: ApiError) => {
      const errorMessage = error.response?.data?.message;
      showToast(
        'error',
        toast,
        'Download Error',
        errorMessage ??
          `Couldn't download the attachment! Please try again later.`,
        3000
      );
    },
  });

  return (
    <div>
      <ErrorToast toastRef={toast} />
      {isFetching && <ProgressSpinner className="w-1rem h-auto" />}
      {!isFetching && (
        <WrapperButton onClick={() => refetch()}>
          <i className="pi pi-paperclip totalColor" />
        </WrapperButton>
      )}
    </div>
  );
};

export default ClaimLogAttachment;
